import { render, staticRenderFns } from "./BookingPriceBreakdown.vue?vue&type=template&id=53e9868a&scoped=true&"
import script from "./BookingPriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./BookingPriceBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./BookingPriceBreakdown.vue?vue&type=style&index=0&id=53e9868a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e9868a",
  null
  
)

export default component.exports